import { baseApi } from '@api/api';
import { ChangelogResponse, ChangelogVersion } from '@models/changelogVersion';
import service from '@util/service';
import { createCache } from 'cross-state';

export default service(
  'websiteApi',
  class WebsiteApi {
    changelog = createCache<ChangelogVersion[]>(async () => {
      const res = await baseApi.get('changelog/versions.json', { prefixUrl: config.BACKEND_WEBSITE }).json();
      const { changelog } = ChangelogResponse.parse(res);
      return changelog;
    });

    useChangelog() {
      const [changelog = []] = this.changelog.useCache();
      const appMinor = config.VERSION.split('.').slice(0, 2).join('.');

      return changelog.find((version) => {
        const minor = version.id.split('.').slice(0, 2).join('.');
        return minor === appMinor;
      });
    }
  },
);
